import { render, staticRenderFns } from "./TaxListAddNew.vue?vue&type=template&id=6109e73d"
import script from "./TaxListAddNew.vue?vue&type=script&lang=js"
export * from "./TaxListAddNew.vue?vue&type=script&lang=js"
import style0 from "./TaxListAddNew.vue?vue&type=style&index=0&id=6109e73d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports